import React, {useRef} from 'react';
import {useNavigation} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';

import {PickerModal} from '/component/screen/Bonuses/PickerModal';

import BonusesConnect from './Bonuses.connect';

export const BonusesNavigator = () => {
  const BonusesStackNavigator = createStackNavigator();
  const navigation = useNavigation();

  const handleDateSelectorPress = useRef((props: any) => {
    // @ts-expect-error TS(2339): Property 'push' does not exist on type 'Navigation... Remove this comment to see the full error message
    navigation.push('date-selector', props);
  });

  const getBonuses = (props: any) => (
    <BonusesConnect
      onDateSelectorPress={handleDateSelectorPress.current}
      {...props}
    />
  );

  const getPickerModal = ({route: {params}}: any) => {
    return <PickerModal {...params} />;
  };

  return (
    <BonusesStackNavigator.Navigator
      initialRouteName="bonuses"
      screenOptions={{headerShown: false}}>
      <BonusesStackNavigator.Screen name="bonuses" component={getBonuses} />
      <BonusesStackNavigator.Screen
        name="date-selector"
        component={getPickerModal}
      />
    </BonusesStackNavigator.Navigator>
  );
};
